/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

const AttendanceSummary = ({ data }) => {
  const [attendanceCount, setAttendanceCount] = useState({});

  useEffect(() => {
    if (data) {
      setAttendanceCount(() => {
        const cal = {
          ...data,
          totalDay: data.present + data.leaves + data.absent
        };
        return cal;
      });
    } else {
      setAttendanceCount({});
    }
  }, [data]);

  return (
    <Card className="h-100 w-100 overflow-hidden">
      <Card.Body className="pt-3">
        <h4 className="mb-1 text-900 fw-semi-bold mb-3">Attendance Summary</h4>
        <div>
          <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-medium">Status</p>
            <p className="mb-0 fs-9">
              Total Day:{' '}
              <span className="fw-medium">
                {attendanceCount.total_staff || '0'}
              </span>
            </p>
          </div>
          <hr className="bg-200 mb-2 mt-2" />

          <div
            className="d-flex align-items-center mb-1"
            key={attendanceCount.present || 0}
          >
            <span className={`d-inline-block bg-info-300 bullet-item me-2`} />
            <p className="mb-0 fw-normal text-900 lh-sm flex-1">Present</p>
            <h6 className="mb-0 fw-normal text-900">
              {attendanceCount.present || 0}
            </h6>
          </div>

          <div
            className="d-flex align-items-center mb-1"
            key={attendanceCount.absent}
          >
            <span className={`d-inline-block bg-danger-300 bullet-item me-2`} />
            <p className="mb-0 fw-normal text-900 lh-sm flex-1">Absent</p>
            <h6 className="mb-0 fw-normal text-900">
              {attendanceCount.absent || 0}
            </h6>
          </div>

          <div
            className="d-flex align-items-center mb-1"
            key={attendanceCount.leaves}
          >
            <span
              className={`d-inline-block bg-warning-300 bullet-item me-2`}
            />
            <p className="mb-0 fw-normal text-900 lh-sm flex-1">Leave</p>
            <h6 className="mb-0 fw-normal text-900">
              {attendanceCount.leaves || 0}
            </h6>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AttendanceSummary;
